import React from "react";
import { Link } from "react-router-dom";
import PNF from "../assets/images/pnf.png";

const PageNotFound = () => {
  return (
    <div className="pagenotfound-wrap">
      <img
        className="pagenotfound"
        src={PNF}
        alt="Error 404 - Page Not Found"
      />
      <h1 className="pagenotfound-title">Page not found</h1>
      <p>The page you are looking for does not exist or has been moved.</p>
      <Link to="/" className="pagenotfound-link" data-consai-guide="pagenotfound-home">
        Back to home
      </Link>
    </div>
  );
};

export default PageNotFound;
